import { createClient } from "@electro-planner/auth/client";

const apiUrl = import.meta.env["VITE_API_URL"] ?? "http://localhost:4000";

export const authClient = createClient(apiUrl);
